import { render, staticRenderFns } from "./MotorTransaction.vue?vue&type=template&id=633f0acd&"
import script from "./MotorTransaction.vue?vue&type=script&lang=js&"
export * from "./MotorTransaction.vue?vue&type=script&lang=js&"
import style0 from "./MotorTransaction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MotorTransaction.vue"
export default component.exports